import { useContext, useMemo, useState } from "react";
import styles from "./styles.module.scss";
import { EViews } from "./typings";
import { getCompanyId as getWorkspaceId } from "utils/getCompanyId";
import workspaceService from "api/workspaceService";
import { IWorkspace } from "dto/IWorkspace";
import { getPrivilages } from "utils/getPrivilages";
import ClassificationDefaultStatus from "../ClassificationDefaultStatus";
import ClassificationClientsStatus from "../ClassificationClientsStatus";
import { AbilityContext, Can } from "contexts/AbilityContext";
import { useTranslation } from "react-i18next";

const ClassificationStatusTab = () => {
  const { t } = useTranslation();
  const { data: workspaceData } = workspaceService.useGetWorkspace(
    getWorkspaceId() ?? "",
  );

  const workspace: IWorkspace = useMemo(
    () => (workspaceData?.data as IWorkspace) ?? [],
    [workspaceData],
  );

  const workspaceMembers = useMemo(() => workspace?.Members ?? [], [workspace]);
  const workspaceRoles = useMemo(() => workspace?.Roles ?? [], [workspace]);

  const me = workspaceMembers.find((membership) => membership.IsMe === true);
  const meRole = workspaceRoles.find((role) => role.Id === me?.RoleId);
  const myPrivilages = getPrivilages(meRole);

  const ability = useContext(AbilityContext);
  const [actualView, setActualView] = useState<EViews>(
    ability.can("accessModule", "cases") ? EViews.CASES : EViews.CLIENTS,
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.menu}>
        <Can I="accessModule" an="cases">
          <div
            onClick={() => setActualView(EViews.CASES)}
            className={`${styles.box}  ${
              actualView === EViews.CASES && styles.activeText
            }`}
          >
            {t("sidebar.cases")}
          </div>
        </Can>
        <Can I="accessModule" an="tasks">
          <div
            onClick={() => setActualView(EViews.ACTIONS)}
            className={`${styles.box}  ${
              actualView === EViews.ACTIONS && styles.activeText
            }`}
          >
            {t("menu.tasks")}
          </div>
        </Can>
        <div
          onClick={() => setActualView(EViews.CLIENTS)}
          className={`${styles.box}  ${
            actualView === EViews.CLIENTS && styles.activeText
          }`}
        >
          {t("participants.title")}
        </div>
        <Can I="accessModule" an="drive">
          <div
            onClick={() => setActualView(EViews.LETTERS)}
            className={`${styles.box}  ${
              actualView === EViews.LETTERS && styles.activeText
            }`}
          >
            {t("classificationStatusTab.files")}
          </div>
        </Can>
        <div
          onClick={() => setActualView(EViews.PACKAGES_INCOMING)}
          className={`${styles.box}  ${
            actualView === EViews.PACKAGES_INCOMING && styles.activeText
          }`}
        >
          {t("settings.classificationIncoming")}
        </div>
        <div
          onClick={() => setActualView(EViews.PACKAGES_OUTCOMING)}
          className={`${styles.box}  ${
            actualView === EViews.PACKAGES_OUTCOMING && styles.activeText
          }`}
        >
          {t("settings.classificationOutgoing")}
        </div>
        <div
          onClick={() => setActualView(EViews.INVOICES)}
          className={`${styles.box}  ${
            actualView === EViews.INVOICES && styles.activeText
          }`}
        >
          {t("payments.invoices")}
        </div>
        <div
          onClick={() => setActualView(EViews.ENGAGEMENTS)}
          className={`${styles.box}  ${
            actualView === EViews.ENGAGEMENTS && styles.activeText
          }`}
        >
          Zaangażowania
        </div>
      </div>

      {actualView !== EViews.CLIENTS && (
        <ClassificationDefaultStatus
          myPrivilages={myPrivilages}
          type={actualView}
        />
      )}
      {actualView === EViews.CLIENTS && (
        <ClassificationClientsStatus
          myPrivilages={myPrivilages}
          type={actualView}
        />
      )}
    </div>
  );
};

export default ClassificationStatusTab;
